import { useTranslation } from 'react-i18next'

import { GetActiveLoadboardsApiV1LoadboardsActiveGet200Item } from '#/shared/api/generated/loadboard/models'
import { useGetActiveLoadboardsApiV1LoadboardsActiveGet } from '#/shared/api/generated/loadboard/theCargoLoadboard'
import type { LoadboardChoice } from '#/shared/api/generated/shipment/models'
import { ActionMenu } from '#/shared/ui/action-menu'
import { Button } from '#/shared/ui/button'
import { ChevronDownIcon, UploadIcon } from '#/shared/ui/icons'

import { usePostToLoadboard } from '../model/use-post-to-loadboard'

export type PostTarget = GetActiveLoadboardsApiV1LoadboardsActiveGet200Item

const LABEL_KEY: Record<PostTarget, string> = {
  [GetActiveLoadboardsApiV1LoadboardsActiveGet200Item.central]:
    'detailToolbar.postOptions.cd',
  [GetActiveLoadboardsApiV1LoadboardsActiveGet200Item.super]:
    'detailToolbar.postOptions.slb',
  [GetActiveLoadboardsApiV1LoadboardsActiveGet200Item.both]:
    'detailToolbar.postOptions.both',
}

export interface PostToLBDropdownProps {
  label: string
  shipmentId?: string
  onPosted?: () => void
}

export function PostToLBDropdown({
  label,
  shipmentId,
  onPosted,
}: PostToLBDropdownProps) {
  const { t } = useTranslation()
  const query = useGetActiveLoadboardsApiV1LoadboardsActiveGet()
  const targets = query.data?.data ?? []
  const { post, isPending } = usePostToLoadboard(shipmentId, { onPosted })

  if (targets.length === 0) {
    return (
      <Button size="xs" className="gap-2.5 px-2.5" disabled>
        <UploadIcon className="size-4" />
        {label}
        <ChevronDownIcon className="size-2.5" />
      </Button>
    )
  }

  const items = targets.map((target) => ({
    value: target,
    label: t(LABEL_KEY[target]),
  }))

  if (items.length === 1) {
    const only = items[0]
    return (
      <Button
        size="xs"
        className="gap-2.5 px-2.5"
        disabled={isPending}
        onClick={() => post(only.value as LoadboardChoice)}
      >
        <UploadIcon className="size-4" />
        {only.label}
      </Button>
    )
  }

  return (
    <ActionMenu
      label={label}
      items={items}
      align="center"
      panelClassName="min-w-35"
      triggerClassName="gap-2.5"
      triggerStartIcon={<UploadIcon className="size-4" />}
      onSelect={(value) => {
        if (isPending) return
        post(value as LoadboardChoice)
      }}
    />
  )
}
